/**
 * Pie de página: una sola línea separada por un borde. Es información de
 * cortesía, así que baja de tamaño y contraste en vez de ocupar 8 de padding.
 */
const Footer = () => {
  return (
    <footer className="mt-auto border-t border-gray-200/70 dark:border-white/10">
      <div className="mx-auto w-full max-w-[1400px] px-4 py-5 md:px-6 lg:px-8">
        <p className="select-none text-center text-[12px] text-gray-700 dark:text-gray-500">
          © {new Date().getFullYear()} TF
        </p>
      </div>
    </footer>
  );
};

export default Footer;
